import TargetAudiences from './components/TargetAudiences';

export default TargetAudiences;
